export const getHost = () => {
   let url = new URL(window.location.href);
   let host = url.hostname;
   if (host === "localhost") host = "tripindigo.com";
   const searchParams = new URLSearchParams(window.location.search);
   let fixedHost = searchParams.get("fixedHost");
   if (fixedHost) {
      host = fixedHost;
   }
   console.log({ host, isWWWW: host.startsWith("www.") });
   if (host.startsWith("www.")) {
      host = host.replace("www.", "");
   }
   host = host.startsWith("book.") ? host : `book.${host}`;
   console.log({ host });
   return host;
};

export const BASE_URL = `https://${getHost()}`;
export const SUPPLIER_BASE_URL = `${BASE_URL}/api/suppliers`;
export const HARDCODED_SUPPLIER_ID = "7d92d5ce-4366-4291-ab8c-b228c2ede75e";
export const HARDCODED_PRODUCT_ID = "a15d84a7-254c-4bab-ab0e-5a4ccb328222";

export const getSupplierUrl = () => {
   let supplierUrl = `${SUPPLIER_BASE_URL}/${getHost()}`;
   return supplierUrl;
};
export const getTravellers = (s) => {
   let travellers = [];
   if (s.showResidentOptions) {
      travellers.push(
         {
            name: "adults",
            label: `${s.internationalName || "International"} adults`,
            hint: `${s.maxChildAge}+ years`,
            isAdult: true,
         },
         {
            name: "adultsRes",
            label: `${s.residentName || "Resident"} adults`,
            hint: `${s.maxChildAge}+ years`,
            isAdult: true,
         }
      );
      if (s.allowChildren) {
         travellers.push(
            {
               name: "children",
               label: `${s.internationalName || "International"} children`,
               hint: `Up to ${s.searchChildAge}`,
            },
            {
               name: "childrenRes",
               label: `${s.residentName || "Resident"} children`,
               hint: `Up to ${s.searchChildAge}`,
            }
         );
      }
   } else {
      travellers.push({
         name: "adults",
         label: "Adults",
         hint: `${s.searchChildAge}+ years`,
         isAdult: true,
      });
      if (s.allowChildren) {
         travellers.push({ name: "children", label: "Children", hint: `Up to ${s.searchChildAge}` });
      }
   }

   return travellers;
};
export const getHotelsUrl = (supplierId) => {
   return `https://${getHost()}/api/locations/hotels?${new URLSearchParams({
      supplierId: supplierId,
   })}`;
};
export const getSupplierLocationsUrl = (supplierId, origin = true) => {
   return `https://${getHost()}/api/supplierlocations/${supplierId}/${origin}`;
};
export const getSupplierProductsUrl = (supplierId, productTypeId, origin = true) => {
   return `https://${getHost()}/api/supplierproducts/categories/${supplierId}/${productTypeId}/${origin}`;
};
export const getSupplierPagesUrl = (supplierId) => {
   return `https://${getHost()}/api/supplierpages/${supplierId}`;
};
export const getDeparturesUrl = (supplierId) => {
   return `${BASE_URL}/api/airports/${supplierId}`;
};
export function hexToRgbA(hex, saturation = 1) {
   var c;
   if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length === 3) {
         c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",")}, ${saturation})`;
   }
   throw new Error("Bad Hex");
}

export const getDestinationsUrl = (supplierId, departureId) => {
   return `${BASE_URL}/api/airports/${supplierId}/${departureId}`;
};
export const getCreateSearchUrl = () => {
   return `${BASE_URL}/api/itineraries/create`;
};
export const getRedirectUrl = (searchId) => {
   return `${BASE_URL}/search/${searchId}`;
};
export const getPackagesRedirectUrl = (params) => {
   return `https://${getHost()}/search/packages?${new URLSearchParams({ ...params })}`;
};

export const getSearchPayloadTransfer = (supplierId, productId, data) => {
   console.log("Data payload: ", data);
   function getVal(name) {
      return data[name];
   }
   let fromTime = getVal("departure_time");
   let toTime = getVal("return_time");
   let fromDate = data.departure_date ? `${data.departure_date}T${fromTime || "00:00"}:00.000Z` : undefined;
   let toDate = data.return_date ? `${data.return_date}T${toTime || "00:00"}:00.000Z` : undefined;
   let trips = [
      {
         fromDate: fromDate,
         toDate: toDate,
         productType: {
            id: productId,
         },
         origin: {
            id: data.location.location.id,
         },
         destination: {
            id: data.dropoff.location.id,
         },
         originSupplierLocation: {
            id: data.location.id,
            location: {
               id: data.location.location.id,
            },
         },
         destinationSupplierLocation: {
            id: data.dropoff.id,
            location: {
               id: data.dropoff.location.id,
            },
         },
         ...data.travellers,
      },
   ];

   if (toDate) {
      trips.push({
         fromDate: fromDate,
         toDate: toDate,
         productType: {
            id: productId,
         },
         destination: {
            id: data.location.location.id,
         },
         origin: {
            id: data.dropoff.location.id,
         },
         destinationSupplierLocation: {
            id: data.location.id,
            location: {
               id: data.location.location.id,
            },
         },
         originSupplierLocation: {
            id: data.dropoff.id,
            location: {
               id: data.dropoff.location.id,
            },
         },
         ...data.travellers,
      });
   }

   let request = {
      supplierId: supplierId,
      fromDate,
      toDate,
      items: trips,
   };

   return request;
};
export const getSearchPayloadCarHire = (supplierId, productId, data) => {
   function getVal(name) {
      return data[name];
   }
   console.log("Data payload: ", data);
   let fromTime = getVal("departure_time");
   let toTime = getVal("return_time");
   let fromDate = data.departure_date ? `${data.departure_date}T${fromTime || "00:00"}:00.000Z` : undefined;
   let toDate = data.return_date ? `${data.return_date}T${toTime || "00:00"}:00.000Z` : undefined;
   let trips = [
      {
         fromDate,
         toDate,
         productType: {
            id: productId,
         },
         origin: {
            id: data.location.location.id,
         },
         destination: {
            id: data.dropoff.location.id,
         },
         originSupplierLocation: {
            id: data.location.id,
            location: {
               id: data.location.location.id,
            },
         },
         destinationSupplierLocation: {
            id: data.dropoff.id,
            location: {
               id: data.dropoff.location.id,
            },
         },
         ...data.travellers,
      },
   ];

   let request = {
      supplierId: supplierId,
      fromDate,
      toDate,
      items: trips,
   };

   return request;
};
export const getSearchPayloadHotel = (supplierId, productId, data) => {
   function getVal(name) {
      return data[name];
   }
   console.log("Data payload: ", data);
   let fromTime = getVal("departure_time");
   let toTime = getVal("return_time");
   let fromDate = data.departure_date ? `${data.departure_date}T${fromTime || "00:00"}:00.000Z` : undefined;
   let toDate = data.return_date ? `${data.return_date}T${toTime || "00:00"}:00.000Z` : undefined;
   let searchLocId = data.location.group ? data.location.group.id : data.location.id;
   let hotelsId = data.location.group ? data.location.id : data.location.hotels[0].id;
   let trips = [
      {
         fromDate,
         toDate,
         productType: {
            id: productId,
         },
         keywords: data.location.isGroup ? "" : data.location.name,
         searchLocation: {
            id: searchLocId,
            name: data.location.name,
            hotels: data.location.isGroup
               ? data.location.groupChildren.map((c) => ({ id: c.id, name: c.name }))
               : [
                    {
                       id: hotelsId,
                    },
                 ],
         },
         rooms: data.rooms,
         ...data.travellers,
      },
   ];

   let request = {
      supplierId: supplierId,
      ...data.travellers,
      items: trips,
   };

   return request;
};

export const getSearchPayloadExperience = (supplierId, productId, data, originSupplierLocation, searchLocation) => {
   function getVal(name) {
      return data[name];
   }
   console.log("Data payload: ", data);
   let fromTime = getVal("departure_time");
   let fromDate = data.departure_date ? `${data.departure_date}T${fromTime || "00:00"}:00.000Z` : undefined;
   let trips = [
      {
         fromDate,
         productType: {
            id: productId,
         },
         origin: {
            id: searchLocation ? originSupplierLocation.location.id : data.location.location.id,
         },
         destination: data.destination
            ? {
                 id: data.destination.id,
              }
            : undefined,
         searchLocation,
         originSupplierLocation,
         ...data.travellers,
      },
   ];

   let request = {
      supplierId: supplierId,
      ...data.travellers,
      items: trips,
   };

   return request;
};

export const getSearchPayload = (supplierId, productId, data) => {
   function getVal(name) {
      return data[name];
   }
   console.log("Data payload: ", data);
   let fromTime = getVal("departure_time");
   let toTime = getVal("return_time");
   let fromDate = data.departure_date ? `${data.departure_date}T${fromTime || "00:00"}:00.000Z` : undefined;
   let toDate = data.return_date ? `${data.return_date}T${toTime || "00:00"}:00.000Z` : undefined;
   let trips = [
      {
         fromDate,
         productType: {
            id: productId,
         },
         origin: {
            id: data.location.id,
         },
         destination: data.destination
            ? {
                 id: data.destination.id,
              }
            : undefined,
         ...data.travellers,
      },
   ];
   if (data.returnTrip) {
      trips.push({
         fromDate: toDate,
         productType: {
            id: productId,
         },
         origin: {
            id: data.destination.id,
         },
         destination: {
            id: data.location.id,
         },
         ...data.travellers,
      });
   }

   let request = {
      supplierId: supplierId,
      ...data.travellers,
      items: trips,
   };

   return request;
};

export function debugColors(root, colors) {
   let parent = root.querySelector(".colors-root");
   if (!parent) {
      parent = document.createElement("div");
      parent.classList.add("colors-root");
      parent.style.display = "flex";
      parent.style.gap = "0.4em";
      root.appendChild(parent);
   }
   parent.innerHTML = "";
   Object.entries(colors).forEach(([key, val]) => {
      let el = document.createElement("div");
      el.style.width = "20em";
      el.style.height = "5em";
      el.style.backgroundColor = hexToRgbA(val);
      el.textContent = `${key}`;
      parent.appendChild(el);
   });
}

export const submitSearch = (request, setError) => {
   let createUrl = getCreateSearchUrl();
   fetch(createUrl, {
      method: "POST",
      headers: {
         "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
   })
      .then((res) => res.json())
      .then((json) => {
         console.log("Response: ", json);
         if (!json.id) {
            setError("Check your inputs and resubmit the search");
            return;
         }
         let redirectUrl = getRedirectUrl(json.id);
         if (!redirectUrl) {
            setError("Check your inputs and resubmit the search");
            return;
         }
         setTimeout(function () {
            window.location.href = redirectUrl;
         }, 100);
      })
      .catch((err) => {
         console.error("Error: ", err);
      });
};

export function generateNumbers(from, to, step = 1) {
   let numbers = [];
   for (let i = from; i <= to; i = i + step) numbers.push(i);
   return numbers;
}

export function deltaDates(date1, date2) {
   const date1Obj = new Date(date1);
   const date2Obj = new Date(date2);
   let timeDifference = date2Obj - date1Obj;
   console.log("Time diff: ", timeDifference);
   const isBefore = timeDifference >= 0;
   if (!isBefore) {
      timeDifference = timeDifference * -1;
   }
   const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
   const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
   const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

   return {
      isBefore,
      days: days,
      hours: hours,
      minutes: minutes,
   };
}

export const getDatePlus = (incr, date) => {
   let d = date || new Date();
   d.setDate(d.getDate() + incr);
   return d;
};

export const removeDuplicates = (arr, field) => {
   const uniqueIds = [];
   const unique = arr.filter((element) => {
      const isDuplicate = uniqueIds.includes(element[field]);
      if (!isDuplicate) {
         uniqueIds.push(element[field]);
         return true;
      }
      return false;
   });

   return unique;
};
